import { useIntl } from 'react-intl';
import type TrailTraffic from '@alltrails/trails/types/TrailTraffic';
import getTrailTrafficLabel from '@alltrails/trails/utils/getTrailTrafficLabel';
import ExploreServiceFilters from '../../types/ExploreServiceFilters';
import useCheckboxFilterConfig from './useCheckboxFilterConfig';

const trailTrafficValues: TrailTraffic[] = ['light', 'moderate', 'heavy'];

const useTrailTrafficFilterConfig = (
  exploreServiceFilters: ExploreServiceFilters,
  onFiltersChange: (updatedFilters: ExploreServiceFilters) => void
) => {
  const intl = useIntl();

  return useCheckboxFilterConfig({
    exploreServiceFilterKey: 'trailTraffic',
    exploreServiceFilters,
    getValueLabel: trailTraffic => getTrailTrafficLabel(intl, trailTraffic),
    label: intl.formatMessage({ defaultMessage: 'Trail traffic' }),
    onFiltersChange,
    values: trailTrafficValues
  });
};

export default useTrailTrafficFilterConfig;
